import React, { useEffect, useState } from 'react';
import { useAuthStore } from '../../store/authStore';
import { authAPI } from '../../services/api';
import ApprovalPendingModal from './ApprovalPendingModal';

const KakaoCallback: React.FC = () => {
  const { setAuth, setLoading } = useAuthStore();
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalMessage, setApprovalMessage] = useState('');

  useEffect(() => {
    const handleKakaoCallback = async (retryCount = 0) => {
      setLoading(true);
      
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        
        if (!code) {
          throw new Error('카카오 인증 코드가 없습니다.');
        }

        // 재시도 시 사용자에게 알림
        if (retryCount > 0) {
          console.log(`🔄 서버 연결 재시도 중... (${retryCount}/3)`);
        }

        // 백엔드에 카카오 코드 전송
        console.log('🚀 e2b Frontend v3.3.0 - 카카오 로그인 처리');
        console.log('카카오 코드:', code);
        console.log('API 요청 시작');
        const redirectUri = `${window.location.origin}/auth/kakao/callback`;
        console.log('리다이렉트 URI:', redirectUri);
        const response = await authAPI.kakaoLogin(code, redirectUri);
        console.log('API 응답:', response);
        
        const data = response.data;
        const { user, accessToken, refreshToken } = data;
        
        setAuth(user, accessToken, refreshToken);
        
        // 메인 페이지로 리다이렉트
        window.location.href = '/';
      } catch (error: any) {
        console.error('카카오 로그인 오류:', error);
        
        // 타임아웃 또는 네트워크 에러 체크
        const isTimeoutOrNetworkError = 
          error.code === 'ECONNABORTED' || 
          error.message?.includes('timeout') ||
          error.message?.includes('Network') ||
          !error.response;
        
        // 재시도 가능한 경우 3초 후 재시도 (최대 3회)
        if (isTimeoutOrNetworkError && retryCount < 3) {
          console.log(`⏳ 3초 후 재시도 예정... (${retryCount + 1}/3)`);
          setTimeout(() => {
            handleKakaoCallback(retryCount + 1);
          }, 3000);
          return;
        }
        
        // 관리자 승인 필요 메시지 처리
        const errorData = error.response?.data;
        console.log('🔍 카카오 로그인 에러 디버깅:', error);
        console.log('🔍 에러 응답:', error.response);
        console.log('🔍 에러 데이터:', errorData);
        
        if (errorData?.requiresApproval) {
          console.log('🚨 카카오 승인 대기 모달 표시:', errorData.message);
          setApprovalMessage(errorData.message);
          setShowApprovalModal(true);
          return;
        }
        
        // 에러 메시지 개선
        let errorMessage = '카카오 로그인에 실패했습니다.';
        
        if (isTimeoutOrNetworkError) {
          errorMessage = '서버가 응답하지 않습니다.\n' +
            '서버가 시작 중일 수 있으니 30초 후 다시 시도해주세요.\n\n' +
            '💡 Render 무료 플랜은 15분 후 자동 슬립됩니다.';
        } else if (error.response?.status >= 500) {
          errorMessage = '서버에 일시적인 문제가 발생했습니다.\n잠시 후 다시 시도해주세요.';
        } else if (error.response?.status === 400) {
          errorMessage = '카카오 인증에 실패했습니다.\n다시 로그인해주세요.';
        }
        
        alert(errorMessage);
        window.location.href = '/';
      } finally {
        setLoading(false);
      }
    };

    handleKakaoCallback();
  }, [setAuth, setLoading]);

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-slate-700 to-slate-900 rounded-3xl flex items-center justify-center mx-auto mb-4 shadow-lg animate-pulse">
            <span className="text-white font-bold text-2xl" style={{ fontFamily: 'cursive' }}>e</span>
          </div>
          <h2 className="text-xl font-semibold text-slate-800 mb-2">카카오 로그인 처리 중...</h2>
          <div className="flex justify-center space-x-2">
            <div className="w-2 h-2 bg-rose-400 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-pink-400 rounded-full animate-bounce delay-150"></div>
            <div className="w-2 h-2 bg-purple-400 rounded-full animate-bounce delay-300"></div>
          </div>
        </div>
      </div>
      
      {/* 승인 대기 모달 */}
      <ApprovalPendingModal
        isOpen={showApprovalModal}
        onClose={() => {
          setShowApprovalModal(false);
          window.location.href = '/';
        }}
        message={approvalMessage}
      />
    </>
  );
};

export default KakaoCallback;
